import { render, staticRenderFns } from "./Drafts.vue?vue&type=template&id=4870aaee&scoped=true"
import script from "./Drafts.vue?vue&type=script&lang=js"
export * from "./Drafts.vue?vue&type=script&lang=js"
import style0 from "./Drafts.vue?vue&type=style&index=0&id=4870aaee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870aaee",
  null
  
)

export default component.exports